function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useGuid } from '@bydesign-ui/hooks';
import React, { Fragment, memo, useMemo, useRef, useState } from 'react';
import { usePrefixCls } from '@byte-design/config';
import { RcHoverTrigger } from '../../hooks/popper';
import { useDragger } from '../../hooks/region';
import { TooltipContent } from '../tooltip/TooltipContent';
export var SliderDragger = memo(function (props) {
  var name = props.name,
      format = props.format,
      tooltip = props.tooltip,
      _props$draggable = props.draggable,
      draggable = _props$draggable === void 0 ? false : _props$draggable,
      _props$invalid = props.invalid,
      invalid = _props$invalid === void 0 ? false : _props$invalid,
      _props$mode = props.mode,
      mode = _props$mode === void 0 ? 'white' : _props$mode,
      rangeEnd = props.rangeEnd,
      value = props.value,
      tooltipVisible = props.tooltipVisible;
  var id = useGuid();
  var ids = useMemo(function () {
    return [id];
  }, []);
  var elemRef = useRef(null);

  var _useDragger = useDragger(elemRef, name, draggable),
      offset = _useDragger.offset,
      dragging = _useDragger.dragging;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var cls = usePrefixCls('slider-dragger', {
    invalid: invalid,
    dragging: dragging,
    selected: true,
    disabled: !draggable
  });
  var popWrapperCls = usePrefixCls('slider-dragger-pop-wrapper');
  return React.createElement(Fragment, null, React.createElement(RcHoverTrigger, {
    ref: elemRef,
    className: cls,
    triggerId: id,
    style: {
      right: "".concat(rangeEnd !== undefined ? rangeEnd - 16 : offset.x, "px")
    }
  }), React.createElement(TooltipContent, {
    size: "md",
    mode: mode,
    refType: "trigger",
    refId: id,
    triggerIds: ids,
    placement: "top",
    show: tooltipVisible === undefined ? dragging || show : tooltipVisible,
    onVisibleChange: setShow,
    preventOverflow: false,
    arrow: true,
    wrapperClassName: popWrapperCls,
    content: function content() {
      if (tooltip) {
        return tooltip;
      }

      return format ? format("".concat(value)) : "".concat(value);
    }
  }));
});